import { styled } from "styled-components";

export const Ellipse = styled.div`
    position: absolute;
    width: 29.5rem;
    height: 27.3125rem;
    border-radius: 100%;
    filter: blur(1.75rem);
    background-color: rgba(7, 88, 20, 1) !important;
    mix-blend-mode: overlay;
    opacity: 100%;
`

export const EllipseLeft = styled(Ellipse)`
    top: 2rem;
    left: -10.75rem;
`

export const EllipseLeft2 = styled(Ellipse)`
    left: -14.75rem;
    top: calc((16em) + 2.828125rem);
`
export const EllipseLeft3 = styled(Ellipse)`
    width: 15.875rem !important;
    height: 15.875rem !important;
    left: 10rem;
    top: calc((11.5em));
`

export const EllipseRight = styled(Ellipse)`
    top: 15.25rem;
    right: -10.75rem;
`
export const EllipseRightDeep = styled(Ellipse)`
    top: 18rem;
    right: -21.75rem;
    background-color: rgba(26, 189, 84, 1) !important;
    mix-blend-mode: hard-light;
    opacity: 45%;

`

export const EllipseRight2 = styled(Ellipse)`
    top: rem;
    right: -18.75rem;
`
export const EllipseRight3 = styled(Ellipse)`
    top: calc((16em) + 6.828125rem);
    width: 15.875rem !important;
    height: 15.875rem !important;
    right: 10rem;
`